// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-receipt-modal__container {
    padding: 44px 70px;
}

.payment-receipt-modal .modal2__container {
    width: 570px;
}

.payment-receipt-modal__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
}

.payment-receipt-modal__item:first-child {
    margin-top: 0;
}

.payment-receipt-modal__item .baloa-table-column {
    color: var(--primary-dark-color);
    font-weight: var(--font-regular);
}

.payment-receipt-modal__item .baloa-table {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
}`, "",{"version":3,"sources":["webpack://./src/app/payments/components/payment-receipt-modal/PaymentReceiptModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;AACnC","sourcesContent":[".payment-receipt-modal__container {\n    padding: 44px 70px;\n}\n\n.payment-receipt-modal .modal2__container {\n    width: 570px;\n}\n\n.payment-receipt-modal__item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 16px;\n}\n\n.payment-receipt-modal__item:first-child {\n    margin-top: 0;\n}\n\n.payment-receipt-modal__item .baloa-table-column {\n    color: var(--primary-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.payment-receipt-modal__item .baloa-table {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
